import { format } from "d3";
import { push } from 'connected-react-router'
import { LinkStuff } from '../interface/MyInterfaces'
import { handleReportDisplayIdChange_VendorReport, authenticateUserOutsideLogin } from './UserActions';
import { percentageFormat, arrayToCsv, billionNumberFormat, numberWithCommas, isAgg } from '../components/Common/Helpers';
import { authHeader } from '../javascript/auth-header';
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import * as Helpers from '../components/Common/Helpers';
import { setTab1, setTab4, setTab1_section2Text } from './LoadNewVendorReportText';

let BVD_MATCH_RATES;

export function loadVendorReport(display_id) {
    return dispatch => {
        let census_vintage = "2019Q4A";
        dispatch(loadVendorProfile(display_id, census_vintage, 2));
        dispatch(loadStates());
    }
}

export function loadStates() {
    return dispatch => {
        let url = "/IRISReportsMicroservice/api/SpendingReport/states";

        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "US_STATES",
                    payload: json
                });
            });
    };
}


export function loadNewVendorSharedReport(link_id, p1, p2) {
    return dispatch => {
        let url =
            "/IRISReportsMicroservice/api/SharedLink/report_link/" + link_id + "/" + p1 + "/" + p2;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(async function (json) {
                var link: LinkStuff = json;
                if (link.link_id == -1) {
                    dispatch({
                        type: "BAD_LINK",
                        payload: json
                    });
                    dispatch(push('/reports/bad_link'));
                } else {
                    authenticateUserOutsideLogin().then(userFound => {
                        dispatch(handleReportDisplayIdChange_VendorReport({ value: link.display_id }));

                        userFound.report_vintage_vendor = link.vintage;
                        dispatch({
                            type: "SAVE_REPORT_VINTAGE_VENDOR",
                            payload: userFound
                        })    
                        dispatch(loadNewVendorReportTab1(link.display_id, "2019Q4A", link.vintage));

                        dispatch(loadVendorReport(link.display_id));
                    });


                }
            });
    };
}

export function loadReleaseDate(display_id, vintage) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/VendorReport/get_vendor_release_date/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "VENDOR_RELEASE",
                    payload: json['release_date']
                })
            });
    };
}

// TODO: correct multiple nested actions creator functions such as this (loadHomeState_AndOtherStuff) into single-purpose functions
// ... each action creator which makes an API call should not call other action creators which also makes API calls
export function loadHomeState_AndOtherStuff(display_id, vintage) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/VendorReport/homestate/' + display_id;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "HOMESTATE",
                    payload: json[0]
                });
                dispatch(loadTrendLinesParagraph(display_id, json[0], vintage));   
                dispatch(loadReleaseDate(display_id, vintage));
            });
    };
}

export function loadSunburstBVDData(display_id, vintage, homestate, year_range, bvdmatchrates) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/VendorReport/get_sunburst_bvd_data/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_SUNBURST_BVD_DATA",
                    payload: json
                })
                dispatch(loadSunburstBVDBulletPoint(display_id, vintage, homestate, year_range, bvdmatchrates, json));
                
            });
    };
}

export function loadSunburstBVDBulletPoint(display_id, vintage, homestate, year_range, bvdmatchrates, bvddata) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/VendorReport/get_bvd_sunburst_bulletpoint/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_BVD_SUNBURST_BULLETPOINT",
                    payload: json
                })
                dispatch(setTab4(display_id, homestate, bvddata, year_range, bvdmatchrates, json));
            });
        
    };
}

export function loadVendorProfile(display_id, census_vintage, naics_level) {
    return dispatch => {
        let url = '/IRISCodeFirst/api/VendorReport/vendor_profile/' + display_id + '/' + census_vintage + '/' + naics_level;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "VENDOR_PROFILE",
                    payload: json
                })
            });
    };
}

// TODO: correct multiple nested actions creator functions such as this (loadHomeState_AndOtherStuff) into single-purpose functions
// ... each action creator which makes an API call should not call other action creators which also makes API calls
export function loadNewVendorReportTab1(display_id, census_vintage, vintage) {
    return dispatch => {
        dispatch(loadHomeState_AndOtherStuff(display_id, vintage));
        dispatch(loadStates());
    }
}


export function loadVendorProfilesByYear(display_id, vintage, homestate, trendspar, bvdmatchrates) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/VendorReport/get_vendor_profiles_by_year/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_VENDOR_PROFILES_BY_YEAR",
                    payload:
                        json.map((data) => {

                            return {
                                start_year: data.start_year,

                                total_pmt: data.total_pmt,
                                business_pmt_amt: data.business_pmt_amt,
                                women_pmt_amt: data.women_pmt_amt,
                                minority_pmt_amt: data.minority_pmt_amt,
                                small_business_pmt_amt: data.small_business_pmt_amt,

                                women_pct: data.women_pct,
                                minority_pct: data.minority_pct,
                                pct_wmn_min: data.pct_wmn_min,

                                small_bus_pct: data.small_bus_pct,
                                agg_women_pct: data.agg_women_pct,
                                agg_minority_pct: data.agg_minority_pct,
                                agg_small_bus_pct: data.agg_small_bus_pct,

                                total_estab: data.total_estab,
                                business_estab_ct: data.business_estab_ct,
                                women_estab_ct: data.women_estab_ct,
                                minority_estab_ct: data.minority_estab_ct,
                                wmn_min_estab_ct: data.wmn_min_estab_ct,
                                small_business_estab_ct: data.small_business_estab_ct,

                                women_estab_pct: data.women_estab_pct,
                                minority_estab_pct: data.minority_estab_pct,
                                small_bus_estab_pct: data.small_bus_estab_pct,

                                agg_women_estab_pct: data.agg_women_estab_pct,
                                agg_minority_estab_pct: data.agg_minority_estab_pct,
                                agg_small_bus_estab_pct: data.agg_small_bus_estab_pct
                            }
                        })
                })
                dispatch(setTab1(display_id, homestate, trendspar, bvdmatchrates));
                dispatch(setTab1_section2Text(display_id, homestate, json, trendspar[0].max_year)); 
                dispatch(loadSunburstBVDData(display_id, vintage, homestate, trendspar, bvdmatchrates));
            });
    };
}

export function sliderChange(display_id, value, HomeState, VendorProfilesByYear) {
    return dispatch => {
        dispatch({
            type: "SELECTED_YEAR",
            payload: value
        })
        dispatch(setTab1_section2Text(display_id, HomeState, VendorProfilesByYear, value));
    }

}

// TODO: correct multiple nested actions creator functions such as this (loadTrendLinesParagraph) into single-purpose functions!
// ... each action creator which makes an API call should not call other action creators which also makes API calls
export function loadTrendLinesParagraph(display_id,homestate,vintage) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/VendorReport/get_trend_lines_paragraph/' + display_id + '/' + vintage;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "GET_TREND_LINES_PARAGRAPH",
                    payload: json
                })
                dispatch({
                    type: "SELECTED_YEAR",
                    payload: json[0].max_year
                })
                dispatch(loadBVDMatchRates(display_id, vintage, homestate, json));
            });
    };
}

export function loadBVDMatchRates(display_id, vintage, homestate, trendspar) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/VendorReport/get_bvd_matchrates/' + display_id + '/' + vintage;
        const agg = isAgg(display_id);
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                BVD_MATCH_RATES = json;
                dispatch({
                    type: "GET_BVD_MATCHRATES",
                    payload: json
                })
                dispatch(loadVendorProfilesByYear(display_id, vintage, homestate, trendspar, json));

                let uniName = agg ? homestate.campusname.replace('Member', 'member').replace('Universities', 'universities') : `your university`;
                let uniNameWithS = uniName + (agg ? '’' : '’s');

                var bvd_match = `For this report, metrics are based on data ${Helpers.aggUniversityAlternateName_LowerCase(uniName)} submitted as of ${json.submission_date.substring(0, 10)}. ${percentageFormat(json.uS_count_pct, 0)} or ${numberWithCommas(json.uS_total_count)} of the ${numberWithCommas(json.total_count)} unique U.S. vendors and subawardees in ${agg ? `participating universities'` : `your university's`} data on that date were identified as being in the U.S., accounting for ${percentageFormat(json.uS_pmt_pct, 0)} or ${billionNumberFormat(json.uS_total_payment_amt)} of ${uniNameWithS} spending. Within the spending identified as occurring with U.S. vendors, ${percentageFormat(json.uS_biz_pmt_pct, 0)} or ${billionNumberFormat(json.uS_biz_total_pmt_amt)} of the spending went to organizations rather than individual people. This included ${numberWithCommas(json.uS_biz_total_count)} organizations. Algorithms matched the vendors and subawardees on ${agg ? `participating universities'` : `your university’s`} list of U.S. organizations to their dataset, using name, street address, city, state, and zip code. ${Math.round(json.matched_business_count_pct * 100) + '%'} or ${numberWithCommas(json.matched_business_total_count)} of these U.S. organizations, accounting for ${Math.round(json.matched_business_pmt_pct * 100) + '%'} of spending, were matched using matching quality rating procedures described in the "How Reports are Created" section. `;

                dispatch({
                    type: "VENDOR_MATCHTAB",
                    payload: { bvd_match: bvd_match } 
                })
            });
    };
}


export function downloadNewVendorReportData(vendorState, userState) {
    return async (dispatch) => {
        let { mapRawData, spendingFlowerRawData, bsRawData, lqFlowerRawData, QCEWNaicsLevel, VendorProfilesByYear, SunburstData, SunburstBVDData, SunburstBulletPoint, TrendsPar, BVDMatchRates } = vendorState;
        const { report_display_id: displayId } = userState;
        const headers = authHeader();
        const vintage = userState.report_vintage_vendor;
        //if (!mapRawData) {
        //    let url = `/IRISReportsMicroservice/api/VendorReport/vendor-spending-map/${displayId}/${QCEWNaicsLevel}/${vintage}`;
        //    let mapResponse = await fetch(url, { method: 'GET', headers: headers });
        //    mapRawData = await mapResponse.json();
        //}
        //if (!spendingFlowerRawData) {
        //    let url = `/IRISReportsMicroservice/api/VendorReport/spending-flower/${displayId}/${QCEWNaicsLevel}/${vintage}`;
        //    let spendingFlowerResponse = await fetch(url, { method: 'GET', headers: headers });
        //    spendingFlowerRawData = await spendingFlowerResponse.json();
        //}
        //if (!lqFlowerRawData) {
        //    let url = `/IRISReportsMicroservice/api/VendorReport/lq-flower/${displayId}/${QCEWNaicsLevel}/${vintage}`;
        //    let lqFlowerResponse = await fetch(url, { method: 'GET', headers: headers });
        //    lqFlowerRawData = await lqFlowerResponse.json();
        //}
        //if (!bsRawData) {
        //    let url = `/IRISReportsMicroservice/api/VendorReport/beeswarm/${displayId}/${QCEWNaicsLevel}/${vintage}`;
        //    let bsResponse = await fetch(url, { method: 'GET', headers: headers });
        //    bsRawData = await bsResponse.json();
        //}
        const vendorProfilesByYearCsv = arrayToCsv({ data: VendorProfilesByYear });
        //const sunburstCsv = arrayToCsv({ data: SunburstData });
        const sunburstBVDCsv = arrayToCsv({ data: SunburstBVDData });
        const sunburstBulletPointCsv = arrayToCsv({ data: SunburstBulletPoint });
        const spendingTrendCsv = arrayToCsv({ data: TrendsPar });
        const BVDMatchRatesCsv = arrayToCsv({ data: [BVDMatchRates] });

        const spendingMapCsv = arrayToCsv({ data: mapRawData });
        const spendingFlowerCsv = arrayToCsv({ data: spendingFlowerRawData });
        const lqFlowerCsv = arrayToCsv({ data: lqFlowerRawData });
        const bsCsv = arrayToCsv({ data: bsRawData });

        const zip = new JSZip();
        zip.file('vendorProfilesByYear.csv', vendorProfilesByYearCsv);
        //zip.file("sunburst.csv", sunburstCsv);
        zip.file("sunburstBVD.csv", sunburstBVDCsv);
        zip.file("sunburstBulletPoint.csv", sunburstBulletPointCsv);
        zip.file("spendingTrend.csv", spendingTrendCsv);
        zip.file("BVDMatchRates.csv", BVDMatchRatesCsv);

        const name = 'VendorReportReadMe.pdf'
        fetch('./dist/downloads/' + name)
            .then(res => res.arrayBuffer())
            .then(ab => {
                zip.file('readme.pdf', ab);
                zip.generateAsync({ type: "blob" })
                    .then(function (blob) {
                        saveAs(blob, "VendorReportData.zip");
                    });
                dispatch({ type: "DOWNLOAD_VENDOR_REPORT_DATA" });
            })

        //zip.file("spendingMap.csv", spendingMapCsv);
        //zip.file("spendingFlower.csv", spendingFlowerCsv);
        //zip.file("lqFlower.csv", lqFlowerCsv);
        //zip.file("beeswarm.csv", bsCsv);


    }
}